export default __webpack_public_path__ + "static/media/beginChat.42e17072.svg";